import {
  Button,
  Card,
  Center,
  Divider,
  PasswordInput,
  Stack,
  Text,
  TextInput,
  Title,
} from '@mantine/core';
import { BRAND_NAME } from '@reditelji/shared';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from '../api/client';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const request = useMutation({
    mutationFn: (value: string) =>
      api<{ ok: true }>('/auth/login-link', {
        method: 'POST',
        body: JSON.stringify({ email: value }),
      }),
  });

  return (
    <Center mih="100vh">
      <Stack gap="lg" maw={380} w="100%" align="stretch">
        <Stack gap={6} align="center">
          <img
            src="/brand/jatr-logo.png"
            alt={BRAND_NAME}
            style={{ width: 140, height: 'auto' }}
          />
          <Text size="sm" fw={700} c="var(--rr-text-strong)">
            Razpored redarjev
          </Text>
        </Stack>
        <Card withBorder w="100%" padding="lg">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            request.mutate(email);
          }}
        >
          <Stack gap="sm">
            <Title order={3}>Prijava koordinatorja</Title>
            {request.isSuccess ? (
              <Text size="sm">Če je naslov na seznamu, smo poslali povezavo za prijavo.</Text>
            ) : (
              <>
                <TextInput
                  label="E-poštni naslov"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.currentTarget.value)}
                />
                <Button type="submit" loading={request.isPending}>
                  Pošlji povezavo za prijavo
                </Button>
                {request.isError ? (
                  <Text size="sm" c="red">
                    {request.error.message}
                  </Text>
                ) : null}
              </>
            )}
          </Stack>
        </form>
        {import.meta.env.DEV ? <MasterLogin /> : null}
        </Card>
      </Stack>
    </Center>
  );
}

/**
 * Dev-only shortcut past the magic link: any email + the MASTER_PASSWORD from
 * `.env`. The endpoint exists only when that variable is set, which the API
 * refuses to allow in production; `import.meta.env.DEV` keeps this out of the
 * production bundle as well.
 */
function MasterLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const login = useMutation({
    mutationFn: () =>
      api<{ kind: 'coordinator' | 'volunteer'; redirect: string }>('/auth/master-login', {
        method: 'POST',
        body: JSON.stringify({ email, password }),
      }),
    // Full reload so the app re-reads the session (or lands on the briefing).
    onSuccess: (res) => window.location.assign(res.redirect),
  });

  return (
    <>
      <Divider my="lg" label="Razvojna prijava" labelPosition="center" />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          login.mutate();
        }}
      >
        <Stack gap="sm">
          <Text size="xs" c="dimmed">
            Katerikoli naslov koordinatorja ali prostovoljca + glavno geslo. Samo za razvoj.
          </Text>
          <TextInput
            label="E-poštni naslov"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.currentTarget.value)}
          />
          <PasswordInput
            label="Glavno geslo"
            required
            value={password}
            onChange={(e) => setPassword(e.currentTarget.value)}
          />
          <Button type="submit" variant="default" loading={login.isPending}>
            Prijava z geslom
          </Button>
          {login.isError ? (
            <Text size="sm" c="red">
              {login.error.message}
            </Text>
          ) : null}
        </Stack>
      </form>
    </>
  );
}
